import {ShieldProduct} from 'components/ShieldProduct';
import {formatPriceNumber} from 'core/helpers';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useMemo} from 'react';
import style from './style.module.scss';

export const ProductShieldPricePerOne = () => {
    const productData = useAppSelector(selectProductData);
    const {price, qtyPerUOM} = productData || {};

    const isShowShield = useMemo(() => {
        if (!price || !qtyPerUOM) {
            return false;
        }

        return 1 < qtyPerUOM;
    }, [price, qtyPerUOM]);

    if (!isShowShield) {
        return null;
    }

    return (
        <ShieldProduct
            className={style.main}
            text={`цена за штуку ${formatPriceNumber(price?.piece.price)}`}
            code={'PIECE_PRICE'}
        />
    );
};
